import styles from "./Navbar.module.scss";
/* icons from react-icons pkg */
import {
  MdDashboard,
  MdOutlineLogout,
  MdStarRate,
  MdFolderShared,
  MdDelete,
} from "react-icons/md";

import { useDispatch, useSelector } from "react-redux";
import { uploadFile } from "../service/actionServices";

import { GiCloudyFork } from "react-icons/gi";

import { FaTimes, FaPlus } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";

import { NavLink } from "react-router-dom";

const Navbar = ({ nav, setnav }) => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state.user)
  let userId = userData && userData.userId && userData.userId


  const handleFileChange = (e) => {
    
    dispatch(uploadFile(userId, e.target.files[0]));

  };
  const NavUrl = ({ url, icon, description }) => {
    const checkWindowsSize = () => {
      if (window.innerWidth < 1024) setnav(!nav);
    };
    return (
      <li className={styles.li_navlink}>
        <NavLink
          to={`${url}`}
          exact
          onClick={() => checkWindowsSize()}
          className={({ isActive }) => (isActive ? styles.active : undefined)}
          end>
          {icon}
          <span className={styles.description}>{description}</span>
        </NavLink>
      </li>
    );
  };

  return (
    <div
      className={`${styles.navbar_container} ${
        nav ? styles.navbar_mobile_active : undefined
      }`}>
      <nav className={nav ? undefined : styles.nav_small}>
        {/* logo */}

        <div className={styles.logo}>
          <GiCloudyFork className={styles.logo_icon} />
          <FaTimes
            className={styles.mobile_cancel_icon}
            onClick={() => setnav(!nav)}
          />
        </div>

        {/* Add File Button */}
        <input type="file" id="inputTag" onChange={handleFileChange} />
        <label
          for="inputTag"
          className={
            nav ? styles.addNew : `${styles.addNew} ${styles.addNewShort}`
          }>
          {nav ? (
            // <AiOutlinePlusCircle className={styles.BtnIcon} />
            <FaPlus className={styles.BtnIcon} />

          ) : (
            <FaPlus className={styles.BtnIcon} />
          )}
          {/* {nav ? <span className={styles.Btntext}> Add New File</span> : ""} */}
          {nav ? <span className={styles.Btntext}> Secure New File</span> : ""}
        </label>

        {/* submenu */}

        <ul className={styles.menu_container}>
          <span className={styles.categories}>
            {nav ? "Pages" : <BsThreeDots />}
          </span>

          <NavUrl url="/" icon={<MdDashboard />} description="Home " />

          <NavUrl url="/starred" icon={<MdStarRate />} description="Starred " />

          <NavUrl
            url="/sharedFile"
            icon={<MdFolderShared />}
            description="Shared"
            //  description="Shared"
          />
          <NavUrl
            url="/recycle-bin"
            icon={<MdDelete />}
            description="Bin"
            // description="Bin"
          />
        </ul>
        {/* LOGOUT BUTTON */}
        <div
          className={styles.btn_logout}
          onClick={() => {
            setnav(!nav);
          }}>
          <MdOutlineLogout />
        </div>
        {/* ADD BACKGROUND FOR MOBILE */}
      </nav>
    </div>
  );
};

export default Navbar;
